import { request } from '../request'
import { useEnvApi } from '../../composables/useEnvApi'
import { useServerFetch } from '../../composables/useServerFetch'

const RELATED_COMPANIES_API_PATH = '/api/v4/bit/web/trader/detail/related-companies'

export type RelatedCompanyLabel = {
  content?: string
  fontColor?: string
}

export type RelatedCompany = {
  companyId?: string
  companyName?: string
  countryCircleFlag?: string
  countryFlag?: string
  countryName?: string
  foundDate?: string
  ico?: string
  labels?: RelatedCompanyLabel[] | null
  logo?: string
  registrationNumber?: string
  registrationStatus?: number
  registrationStatusFontColor?: string
  registrationStatusName?: string
  relatedSources?: unknown[] | null
}

export type GetRelatedCompaniesParams = {
  traderCode: string
  offset: number
  pageSize: number
}

export type RelatedCompaniesData = {
  items?: RelatedCompany[] | null
  total?: number
}

export type RelatedCompaniesResponse = {
  code?: number
  data?: RelatedCompaniesData | null
  message?: string
  succeed?: boolean
}

/**
 * 获取交易商的关联公司列表。
 * @param params 查询参数，包含交易商编码、偏移量和每页数量。
 * @returns 关联公司接口原始响应。
 */
export const getRelatedCompanies = async ({
  traderCode,
  offset,
  pageSize,
}: Readonly<GetRelatedCompaniesParams>): Promise<RelatedCompaniesResponse | null> => {
  if (!traderCode) {
    return null
  }

  const api = useEnvApi()
  const params = {
    traderCode,
    offset,
    pageSize,
  }

  const response = import.meta.server
    ? await useServerFetch<RelatedCompaniesResponse>({
        baseURL: api.wikibitBffGo,
        url: RELATED_COMPANIES_API_PATH,
        method: 'GET' as const,
        query: params,
      })
    : await request<unknown, RelatedCompaniesResponse>({
        baseURL: api.v4,
        url: RELATED_COMPANIES_API_PATH,
        method: 'GET' as const,
        params,
      })

  return response
}
